
import axios from '../../helpers/axios';


export const deletedApplicationCallMe = (id) => axios.delete(`/applicationCallMe/delete/${id}`)
